// Stores
import Stores from '@/store/index'
// importamos los tipos de mutación de vuex
import * as types from '@/store/mutation-types'
import api from '@/services/axiosInstanceIA.js'

export default {
  /*getAuthTulxy() {
    return new Promise((resolve, reject) => {
      // mostramos Loading
      Stores.commit(types.PENDING)
      let query = `${urlApi}token/`
      // llamada a la API
      axios.defaults.headers.common['Authorization'] = ''
      axios.post(query, {username: "api@tulxy.com", password: "testpassword123"})
        .then(res => {
          // Ocultamos Loading
          Stores.commit(types.NOT_PENDING)
          resolve(res)
        })
        .catch(error => {
          // Ocultamos Loading
          Stores.commit(types.NOT_PENDING)
          const status = error.response.status
          if (status === 401) {
            //SrvCommon.logout()
          }
          reject(error)
        })
    })
  },*/
  getTokenTulxy() {
    return `0c367eea1dfb2362cfedd5b848a874b657674d26`
  },
  getBrand({brand_uuid = null}) {
    return new Promise((resolve, reject) => {
      // mostramos Loading
      Stores.commit(types.PENDING)
      let query = `brand/${brand_uuid}/`
      console.log('leea')
      // llamada a la API
      api.get(query)
        .then(res => {
          // Ocultamos Loading
          Stores.commit(types.NOT_PENDING)
          resolve(res)
        })
        .catch(error => {
          // Ocultamos Loading
          Stores.commit(types.NOT_PENDING)
          const status = error.response.status
          if (status === 401) {
            // SrvCommon.logout()
          }
          reject(error)
        })
    })
  },
  getReputation({brand_uuid = null, site_uuid = null}) {
    return new Promise((resolve, reject) => {
      // mostramos Loading
      Stores.commit(types.PENDING)
      let query = `reputation/?brand_uuid=${brand_uuid}`
      if (site_uuid) {
        query += `&site_uuid=${site_uuid}`
      }
      // llamada a la API
      api.get(query)
        .then(res => {
          // Ocultamos Loading
          Stores.commit(types.NOT_PENDING)
          resolve(res)
        })
        .catch(error => {
          // Ocultamos Loading
          Stores.commit(types.NOT_PENDING)
          const status = error.response.status
          if (status === 401) {
           // SrvCommon.logout()
          }
          reject(error)
        })
    })
  },
  getPrompts({brand_uuid = null, site_uuid = null}) {
    return new Promise((resolve, reject) => {
      // mostramos Loading
      Stores.commit(types.PENDING)
      let query = `prompt/?brand_uuid=${brand_uuid}`
      if (site_uuid) {
        query += `&site_uuid=${site_uuid}`
      }
      // llamada a la API
      api.get(query)
        .then(res => {
          // Ocultamos Loading
          Stores.commit(types.NOT_PENDING)
          resolve(res)
        })
        .catch(error => {
          // Ocultamos Loading
          Stores.commit(types.NOT_PENDING)
          const status = error.response.status
          if (status === 401) {
            // SrvCommon.logout()
          }
          reject(error)
        })
    })
  },
  setPrompt({brand_uuid, site_uuid = null, type, prompt_id, text, method, dimension = null})
    {
      return new Promise((resolve, reject) => {
        const params = new FormData()
        if (brand_uuid) {
          params.append('brand_uuid', brand_uuid)
        }
        if (site_uuid) {
          params.append('site_uuid', site_uuid)
        }
        if (type) {
          params.append('type', type)
        }
        if (prompt_id || prompt_id === 0) {
          params.append('prompt_id', prompt_id)
        }
        if (text) {
          params.append('prompt_text', text)
        }
        if (dimension) {
          params.append('sectoral_dimension', dimension)
        }

        // mostramos Loading
        Stores.commit(types.PENDING)
        let query = `prompt/`
        // llamada a la API
        api[method](query, params)
          .then(res => {
            // Ocultamos Loading
            Stores.commit(types.NOT_PENDING)
            resolve(res)
          })
          .catch(error => {
            // Ocultamos Loading
            Stores.commit(types.NOT_PENDING)
            const status = error.response.status
            if (status === 401) {
              // SrvCommon.logout()
            }
            reject(error)
          })
      })
    },
  deletePrompt({brand_uuid, site_uuid = null, type, prompt_id})
  {
    return new Promise((resolve, reject) => {
      const params = new FormData()
      if (brand_uuid) {
        params.append('brand_uuid', brand_uuid)
      }
      if (site_uuid) {
        params.append('site_uuid', site_uuid)
      }
      if (type) {
        params.append('type', type)
      }
      if (prompt_id || prompt_id === 0) {
        params.append('prompt_id', prompt_id)
      }


      // mostramos Loading
      Stores.commit(types.PENDING)
      let query = `prompt/`
      // llamada a la API
      api.delete(query, {data: params})
        .then(res => {
          // Ocultamos Loading
          Stores.commit(types.NOT_PENDING)
          resolve(res)
        })
        .catch(error => {
          // Ocultamos Loading
          Stores.commit(types.NOT_PENDING)
          const status = error.response.status
          if (status === 401) {
            // SrvCommon.logout()
          }
          reject(error)
        })
    })
  }

}
